module.exports = __webpack_public_path__ + "img/whatsapp-contact.d30cd50b.png";